module.exports = __webpack_public_path__ + "static/media/call out_poi.0aac30c1.svg";